import type { enums, types } from "@fraction/shared";
import { MessageSquare } from "lucide-react";
import { useCallback } from "react";
import { useChatModalStore } from "src/stores/chatModalStore";

import { NotificationCardLayout } from "./NotificationCardLayout";

export function ChatMessageCard({
  notification,
  onDismiss,
  count,
}: {
  notification: types.ChatMessageNotification;
  onDismiss: () => void;
  count?: number;
}) {
  const openChat = useChatModalStore((s) => s.openChat);

  const handleClick = useCallback(() => {
    openChat(notification.applicationId, notification.chatType as enums.ChatType, {
      applicantNames: notification.applicantNames,
      applicationEid: notification.applicationEid,
    });
    onDismiss();
  }, [
    openChat,
    notification.applicationId,
    notification.chatType,
    notification.applicantNames,
    notification.applicationEid,
    onDismiss,
  ]);

  return (
    <NotificationCardLayout
      icon={MessageSquare}
      iconBg="bg-green-100"
      iconColor="text-green-600"
      title="Chat message"
      applicationEid={notification.applicationEid}
      applicantNames={notification.applicantNames}
      onClick={handleClick}
      count={count}
    >
      <p className="truncate text-sm font-semibold text-foreground">{notification.senderName}</p>
      <p className="truncate text-xs text-muted-foreground">{notification.messagePreview}</p>
    </NotificationCardLayout>
  );
}
